import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import noEventsIcon from "./no-events.svg"
import * as css from "./NoEvents.module.css"

function NoEvents({ className, message, narrow, margin }) {
  return (
    <div
      className={cx(className, css.root, {
        [css.narrow]: !!narrow,
        [css.margin]: !!margin,
      })}
    >
      <img className={css.icon} src={noEventsIcon} alt="No events icon" />
      <div>{message}</div>
    </div>
  )
}

NoEvents.propTypes = {
  /** Add additional class names */
  className: PropTypes.string,
  /** Message */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** If true, reduce internal spacing */
  narrow: PropTypes.bool,
  /** If true, add horizontal margin */
  margin: PropTypes.bool,
}

export default NoEvents
